import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoShipmentReturnCode extends IModelEntity {

    code?: string;
    description?: string;
    text?: string;

    mandator?: IDtoMandator;

    fullDescription?: string;

}
